<template>
    <base-modal ref="modal" header-disable footer-disable>
        <template v-slot:body>
            <div class="samo samo-site">
                <form class="login-form" @submit.prevent="register">
                    <div class="form-header">
                        <h1>{{ $t('app.modals.signup.title') }}</h1>
                    </div>
                    <div class="form-group">
                        <label class="control-label samo-label" for="signupName">{{
                            getTranslateSpace($t('app.modals.signup.name_label')) }}</label>
                        <input id="signupName" v-model="name" class="samo-input form-control"
                            :class="{ 'is-invalid': v$.name.$error }" type="text">
                        <small class="error-message" v-if="v$.name.$error">{{
                            $t(...getTranslateParams(v$.name.$errors[0].$message)) }}</small>
                    </div>
                    <div class="form-group">
                        <label class="control-label samo-label" for="signupEmail">{{
                            getTranslateSpace($t('app.modals.signup.email_label')) }}</label>
                        <input id="signupEmail" v-model="login" class="samo-input form-control"
                            :class="{ 'is-invalid': v$.login.$error }" type="email">
                        <small class="error-message" v-if="v$.login.$error">{{
                            $t(...getTranslateParams(v$.login.$errors[0].$message)) }}</small>
                    </div>
                    <div class="form-group">
                        <label class="control-label samo-label" for="signupPassword">{{
                            getTranslateSpace($t('app.modals.signup.password_label')) }}</label>
                        <input id="signupPassword" v-model="password" class="samo-input form-control"
                            :class="{ 'is-invalid': v$.password.$error }" type="password">
                        <small class="error-message" v-if="v$.password.$error">{{
                            $t(...getTranslateParams(v$.password.$errors[0].$message)) }}</small>
                    </div>
                    <div class="form-group">
                        <button class="btn btn-primary text-white" type="submit">{{ $t('app.signup') }}</button>
                    </div>
                    <div class="form-group text-center">
                        <a class="btn-link" href="#" @click="openLogin">{{ $t('app.login') }}</a>
                    </div>
                    <div v-if="infoMessage" class="mt-4 p-3 info-message row g-0">
                        {{ infoMessage }}
                    </div>
                    <div class="error mt-4 p-3" v-if="error">
                        {{ error }}
                    </div>
                </form>
            </div>
        </template>
    </base-modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, helpers } from '@vuelidate/validators'
import BaseModal from '@/components/ui/BaseModal.vue'
import translateMixin from '@/mixins/translate'

export default {
    name: "RegisterModal",
    components: { BaseModal },
    mixins: [ translateMixin ],
    setup() {
        return { 
            v$: useVuelidate() 
        }
    },
    data() {
        return {
            name: null, 
            login: null, 
            password: null,
            isLoading: false,
            error: null,
            infoMessage: null
        }
    },
    validations: {
        name: { required },
        login: { required, mustContainAtSymbol: helpers.withMessage("value_must_contain_a_symbol", (value) => value.includes("@")) },
        password: { required, minLength: minLength(4) }
    },
    methods: {
        open() {
            this.$refs.modal.open();
        },
        register() {
            this.v$.$touch();
            if (!this.v$.$invalid) {
                this.$store.dispatch('users/register', {
                    name: this.name,
                    login: this.login,
                    password: this.password,
                    confirm_url: location.origin + process.env.VUE_APP_BASE_URL + 'activate'
                }).then(() => {
                    this.$refs.modal.close();
                    this.$parent.user.login = this.login;
                    this.$parent.open();
                }).catch((error) => {
                    this.error = error.data.message;
                });
            }
        },
        openLogin() {
            this.$refs.modal.close();
            this.$parent.open();
        }
    }
}
</script>

<style scoped>
.error {
    border: 1px solid var(--bs-danger);
    background: #ffd4d4;
    border-radius: 4px;
    color: var(--bs-danger);
}
</style>